import React, { useEffect, useState } from 'react';
import { Progress, Typography } from 'antd';
import styles from './progresscircle-small.module.sass';
import AnimatedCounter from '../AnimatedCounter';
import cx from 'classnames';

const ProgressCircleSmall = (props) => {
  const { Title, Text } = Typography;
  const [percent, setPercent] = useState(null);
  const [amount, setAmount] = useState(null);
  const [width, setWidth] = useState(0);
  const [color, setColor] = useState('#1f9110');

  useEffect(() => {
    setWidth(props?.width);

    if (props?.amount > 40) {
      setColor('#E84749');
    } else if (props?.amount >= 25) {
      setColor('#f3be00');
    }

    setTimeout(() => {
      setPercent(props?.percent);
      setAmount(props?.amount);
    }, 500);
  }, []);

  return (
    <div className={cx(styles.progressCircleSmall, props.className)}>
      <Progress
        key={`progressCircle-${toString(props.serial)}`}
        className={styles.circle}
        percent={percent ? percent : 0}
        type="circle"
        width={width}
        strokeWidth={12}
        strokeColor={color}
        trailColor={'#1A2F3A'}
        showInfo={false}
      />
      <div className={styles.displayNumbers}>
        <Title level={5} className="m-0">
          <AnimatedCounter
            serial={`${props?.serial}`}
            number={amount ? amount : 0}
            duration={1}
            delay={props?.serial / 5}
          ></AnimatedCounter>
        </Title>
      </div>

      {props?.title && <Text className={styles.title}>{props.title}</Text>}
    </div>
  );
};

export default ProgressCircleSmall;
